import { render } from "./accountModifyPassword.vue?vue&type=template&id=23ecf9d9&scoped=true&ts=true"
import script from "./accountModifyPassword.vue?vue&type=script&lang=ts"
export * from "./accountModifyPassword.vue?vue&type=script&lang=ts"

import "./accountModifyPassword.vue?vue&type=style&index=0&id=23ecf9d9&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ecf9d9"]])

export default __exports__